import { ThemeOptions, createTheme } from "@mui/material/styles";
import { ChevronRight } from "../components/Icons";
import colors from "../styles/colors";

const themeOptions: ThemeOptions = {
  secondaryFontFamily: "'Poppins', sans-serif",
  palette: {
    primary: {
      main: colors.pixelPointBlue,
    },
    secondary: {
      main: colors.darkGray,
    },
    trace: {
      main: "#54b359",
      contrastText: colors.white,
    },
    debug: {
      main: "#54b399",
      contrastText: colors.white,
    },
    warning: {
      main: "#d68e57",
      contrastText: colors.white,
    },
    fatal: {
      main: "#82392b",
      contrastText: colors.white,
    },
  },
  typography: {
    allVariants: {
      color: colors.black,
    },
    fontFamily: "'Roboto', sans-serif;",
    fontWeightBold: 600,
    h1: {
      fontFamily: "'Poppins', sans-serif",
    },
    h2: {
      fontFamily: "'Poppins', sans-serif",
    },
    h3: {
      fontFamily: "'Poppins', sans-serif",
    },
    h4: {
      fontFamily: "'Poppins', sans-serif",
    },
    h5: {
      fontFamily: "'Poppins', sans-serif",
    },
    h6: {
      fontFamily: "'Poppins', sans-serif",
    },
  },

  components: {
    MuiPaper: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiInputLabel: {
      defaultProps: {
        shrink: true,
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "0.3rem",
          boxShadow: "none",
          ":hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: colors.middleLightGray,
          color: colors.pixelPointBlue,
          height: 10,
          borderRadius: 2,
        },
        barColorPrimary: {
          backgroundColor: colors.pixelPointBlue,
          borderRadius: 2,
        },
      },
    },
    MuiBreadcrumbs: {
      defaultProps: {
        separator: <ChevronRight width="18px" color={colors.middleDarkGray} />,
      },
    },
    MuiDialogTitle: {
      styleOverrides: {},
    },
  },
};

export const honeycombTheme = createTheme(themeOptions);
